import { NavLink, Outlet } from 'react-router-dom';

export interface WorkspaceNavItem {
  to: string;
  label: string;
  icon: string;
  end?: boolean;
}

interface WorkspaceShellProps {
  title: string;
  subtitle?: string;
  nav: WorkspaceNavItem[];
}

function navLinkClass(isActive: boolean, compact?: boolean) {
  const base = compact ? 'workspace-mobile-tab' : 'workspace-nav-link';
  return `${base}${isActive ? ' active' : ''}`;
}

export function WorkspaceShell({ title, subtitle, nav }: WorkspaceShellProps) {
  return (
    <div className="workspace">
      <nav className="workspace-mobile-nav" aria-label="Workspace navigation">
        {nav.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => navLinkClass(isActive, true)}
          >
            <span aria-hidden>{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="workspace-grid">
        <aside className="workspace-sidebar" aria-label="Workspace sidebar">
          <div className="workspace-sidebar-inner">
            <p className="workspace-sidebar-title">{title}</p>
            {subtitle ? <p className="workspace-sidebar-sub">{subtitle}</p> : null}
            <nav className="workspace-nav">
              {nav.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) => navLinkClass(isActive)}
                >
                  <span className="workspace-nav-icon" aria-hidden>
                    {item.icon}
                  </span>
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </aside>

        <div className="workspace-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
